import { useRouteMatch } from 'react-router-dom';
import { links } from '../constants/links';

const useHousingStockMatch = () => {
  const match = useRouteMatch({
    path: [
      `${links.root}`,
      `${links.rootWithCompany}/:companyId/:page`,
      `${links.rootWithCompany}/:companyId/:page/:pageId`,
      `${links.rootWithCompany}/:companyId/:page/:pageId/:pageTab`,
      `${links.rootWithCompany}/:companyId/:page/:pageId/:pageTab/:pageTabId`,
    ],
    exact: true,
  });

  return match;
};

export default useHousingStockMatch;
